import { OUT_OF_STOCK_BUTTON } from '../../classnames/out-of-stock';

export default class OutOfStockHandler {
  inStockClass = 'js-visible-in-stock';
  outOfStockClass = 'js-visible-out-of-stock';
  oosEmailSubscriptionTextClass = 'js-out-of-stock-email-subscription-text';
  oosEmailSubscriptionSuccessDescriptionClass = 'js-out-of-stock-email-subscription-success-description';

  handle = ({
    variantId,
    variantOutOfStock,
    productOutOfStock,
    outOfStockEmailSubscriptionText,
    outOfStockEmailSubscriptionSuccessDescription
  }, node) => {
    const outOfStock = variantOutOfStock || productOutOfStock;

    this.updateInStockElements(outOfStock, node);
    this.updateOutOfStockElements(outOfStock, node);
    this.updateOutOfStockButtons(variantId, node);
    this.updateOutOfStockMessages(
      { outOfStockEmailSubscriptionText, outOfStockEmailSubscriptionSuccessDescription }, node
    );
  };

  updateInStockElements = (outOfStock, node) => {
    const elements = node.getElementsByClassName(this.inStockClass);

    [...elements].forEach((element) => {
      if (outOfStock) {
        element.classList.add('hidden');
      } else {
        element.classList.remove('hidden');
      }
    });
  };

  updateOutOfStockElements = (outOfStock, node) => {
    const elements = node.getElementsByClassName(this.outOfStockClass);

    [...elements].forEach((element) => {
      if (outOfStock) {
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });
  };

  updateOutOfStockMessages = ({
    outOfStockEmailSubscriptionText, outOfStockEmailSubscriptionSuccessDescription
  }, node) => {
    const textElements = node.getElementsByClassName(this.oosEmailSubscriptionTextClass);
    const successDescriptionElements = node.getElementsByClassName(this.oosEmailSubscriptionSuccessDescriptionClass);

    [...textElements].forEach((element) => element.innerHTML = outOfStockEmailSubscriptionText);
    [...successDescriptionElements].forEach(
      (element) => element.innerHTML = outOfStockEmailSubscriptionSuccessDescription
    );
  };

  updateOutOfStockButtons = (variantId, node) => {
    const buttons = node.getElementsByClassName(OUT_OF_STOCK_BUTTON);

    [...buttons].forEach((button) => button.setAttribute('data-variant-id', variantId));
  };
}
